"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsMaxUnhiddenCameras = exports.selectIsMaxCamerasOn = exports.selectIsMaxAgoraUnhiddenCameras = exports.selectIsMaxAgoraCamerasOn = exports.selectAgoraActiveCameras = exports.selectActiveCameras = void 0;
var _reselect = require("reselect");
var _constants = require("@studio/constants");
var _broadcastSourcesSelector = require("./broadcastSourcesSelector");
function selectAttendeeCameraStatus(state) {
  return state.attendeeCameraStatus;
}

/**
 * Selects the attendee tiles from the meeting state.
 * @param {Object} state - The Redux state object
 * @returns {Object} Object containing all attendee tiles in the meeting
 */
var selectAttendeeTiles = function selectAttendeeTiles(state) {
  return state.meeting.attendeeTiles;
};
var selectActiveCameras = exports.selectActiveCameras = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectPresenterSources, selectAttendeeCameraStatus, function (presenterSources, attendeeCameraStatus) {
  return presenterSources.filter(function (source) {
    return attendeeCameraStatus[source.value];
  });
});

/**
 * Selects the list of active cameras in an Agora meeting.
 * Filters out screen share attendees (those with '#content' in their ID)
 * and returns only attendees whose cameras are actively turned on.
 * @param {Object} attendeeTiles - Object containing all attendee tiles
 * @param {Object} attendeeCameraStatus - Object mapping attendee IDs to camera status
 * @returns {string[]} Array of attendee IDs with active cameras (excluding screen shares)
 */
var selectAgoraActiveCameras = exports.selectAgoraActiveCameras = (0, _reselect.createSelector)(selectAttendeeTiles, selectAttendeeCameraStatus, function (attendeeTiles, attendeeCameraStatus) {
  var attendeesInMeetings = Object.keys(attendeeTiles);
  // Exclude screen share attendees
  var cameraAttendeesInMeeting = attendeesInMeetings.filter(function (attendeeId) {
    return !attendeeId.includes('#content');
  });
  return cameraAttendeesInMeeting.filter(function (attendeeId) {
    return attendeeCameraStatus[attendeeId] === true;
  });
});
var selectIsMaxUnhiddenCameras = exports.selectIsMaxUnhiddenCameras = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectPresenterSources, selectAttendeeCameraStatus, function (presenterSources, attendeeCameraStatus) {
  var unhiddenCameras = presenterSources.filter(function (source) {
    return attendeeCameraStatus[source.value] && !source.hidden;
  });
  return unhiddenCameras.length >= _constants.CAMERA_PRESENTER_LIMIT;
});
var selectIsMaxAgoraUnhiddenCameras = exports.selectIsMaxAgoraUnhiddenCameras = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectPresenterSources, selectAttendeeCameraStatus, function (presenterSources, attendeeCameraStatus) {
  var unhiddenCameras = presenterSources.filter(function (source) {
    return attendeeCameraStatus[source.value] && !source.hidden;
  });
  return unhiddenCameras.length >= _constants.MAX_AGORA_CAMERA_COUNT;
});
var selectIsMaxCamerasOn = exports.selectIsMaxCamerasOn = (0, _reselect.createSelector)(selectActiveCameras, function (activeCameras) {
  return activeCameras.length >= _constants.CAMERA_PRESENTER_LIMIT;
});
var selectIsMaxAgoraCamerasOn = exports.selectIsMaxAgoraCamerasOn = (0, _reselect.createSelector)(selectActiveCameras, function (activeCameras) {
  return activeCameras.length >= _constants.MAX_AGORA_CAMERA_COUNT;
});